// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2d74i","content":"styles_content__1B-2f"};